$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.primary-title').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);
  function runMyFunction2(){
   $('.rebuy-widget-content h4.primary-title').attr('aria-level', '3');
   $('#rebuy-cart .rebuy-cart__flyout .rebuy-cart__flyout-footer .rebuy-cart__flyout-actions zest-button.zest--width-full.hydrated input').attr('aria-label', 'input');
   $('#rebuy-cart .rebuy-cart__flyout .rebuy-cart__flyout-footer .rebuy-cart__flyout-actions zest-button.zest--width-full.hydrated input').attr('aria-hidden', 'true');
   $('div#rebuy-widget-53977 .rebuy-widget-content .rebuy-product-grid .rebuy-product-info a.rebuy-product-title.clickable').attr('aria-level', '3');
  }
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.rebuy-cart__flyout-empty-cart').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);
  function runMyFunction2(){
    $('.rebuy-cart__flyout-empty-cart h2.ql-align-center').attr('aria-level', '3');
  }
});




$('body').prepend('<span id="rc_popup__block__content" style="font-size:0; position: fixed; top:0;" aria-hidden="true">Hassle free deliveries on your schedule.</span>');
$('li.link_lis.Shop > a').attr('aria-expanded','false');
$("li.link_lis.Shop").click(function(){
  $('li.link_lis.Shop >a').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
  });
  
});
$("li.link_lis.Learn").click(function(){
  $('li.link_lis.Learn >a').attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
  });
  
});

$(".investment-content h3").each(function () {
  var lines = $(this).html().split("<br>");
  $(this).html('<span class="break">' + lines.join("</span><span>") + '</span>');
});
$(".meet-founder p").each(function () {
  var lines = $(this).html().split("<br>");
  $(this).html('<span>' + lines.join("</span><span>") + '</span>');
});
$('.meet-founder p span').each(function(){
    if( $(this).text().trim() === '' )
        $(this).remove();
  });
  $( ".meet-founder p span" ).addClass( "break-2" );

$('li.link_lis.Learn > a').attr('aria-expanded','false');
$('li.link_lis.Shop > a').removeAttr('href');
$('li.link_lis.Learn > a').removeAttr('href');
$('li.link_lis.Learn > a').attr('role','button');
$('li.link_lis.Shop > a').attr('role','button');
$('.search-area.show-icon a').attr('aria-haspopup','dialog');
$('.wow1.bounceInLeft img').attr('aria-hidden','true');
$('.wow1.bounceInRight img').attr('aria-hidden','true');
$('.investment-area .d-image img').attr('aria-hidden','true');
$('.search-area.show-icon .search-extended.has-categories input').attr('id','search');
$('.social-icons a[href="https://www.facebook.com/mylklabs"]').attr('aria-label','Mylk Labs on facebook this link open in new tab');
    $('.social-icons a[href="https://www.instagram.com/mylklabs"]').attr('aria-label','Mylk Labs on instagram this link open in new tab');
    $('.social-icons a[href="https://www.pinterest.com/mylklabs/"]').attr('aria-label','Mylk Labs on pinterest this link open in new tab');
    $('.social-icons a[href="https://www.tiktok.com/@mylklabs"]').attr('aria-label','Mylk Labs on tiktok this link open in new tab');
    $('a[href="https://www.vogue.com/article/5-models-to-know-from-marc-jacobs-spring-2017"]').attr('aria-label','5 Models to Know from Marc Jacobs Spring 2017 and You will leaving mylklabs.com to www.vogue.com/article/5-models-to-know-from-marc-jacobs-spring-2017');
    $('a[href="https://www.vogue.com/article/5-models-to-know-from-marc-jacobs-spring-2017"]').attr('target','_blank');
    $('.detail-price').prepend('<span class="visuallyhidden">Regular Price</span>');
$(document).ready(function () {
  setTimeout(function () {
    $('img#ellhp').attr('alt','img');
$('#more-slides .owl-nav button.owl-prev').append('<span class="visually-hidden">Previous</span>');
$('#more-slides .owl-nav button.owl-next').append('<span class="visually-hidden">Next</span>');
$('.box_product_page .product-img-list button.slick-prev').append('<span class="visually-hidden">Previous</span>');
$('.box_product_page .product-img-list button.slick-next').append('<span class="visually-hidden">Next</span>');
$('.item-320-2.slick-slider button.slick-prev').append('<span class="visually-hidden">Previous</span>');
$('.item-320-2.slick-slider button.slick-next').append('<span class="visually-hidden">Next</span>');
$('.rc-login--header a').append('<span class="visually-hidden">Recharge secured</span>'); 
$('.rc-login-form-container label.rc-login-form-label').append('<span class="visually-hidden">Recharge secured</span>'); 
$('form.rc-enter-code-digits input').attr('aria-label','0'); 
$('.rebuy-product-block').removeAttr('aria-hidden','true'); 
$('.zest--width-full input').attr('aria-label','email'); 
$('.stockist-query-entry input.stockist-search-field').removeAttr('aria-expanded'); 
$('.rebuy-widget-content h3.primary-title').attr('aria-level','2');
$('.postDesc h4').attr('aria-level','2');
$('.zest--width-full.hydrated input').attr('aria-label','empty'); 
$('a.rc_popup__learn_more').append('<span class="visuallyhidden">null</span>'); 
$('a.rebuy-product-title').attr('aria-level','3'); 
$('.rebuy-cart__flyout-empty-cart h4.ql-align-center').attr('aria-level','2'); 
$('.owl-nav button.owl-prev').attr('aria-label','Previous'); 
$('.owl-nav button.owl-next').attr('aria-label','Next'); 
$('.owl-nav button.owl-next').attr('aria-label','Next'); 
$('.loox-image').attr('alt','A group of cups of food'); 
$( ".get-content p:first" ).wrap( "<a aria-label='Email address is support@mylklabs.com' href='mailto:support@mylklabs.com' class='new'></a>" );
$('.postDesc br').attr('aria-hidden','true');
$('.quote-content br').attr('aria-hidden','true');
$('.story-listings br').attr('aria-hidden','true');
$("div#product-variants select.rc_widget__option__plans__dropdown.rc-selling-plans__dropdown").attr("aria-label","recharge subscription");
$('.story-listings .container p:nth-child(2)').attr('role','heading');
$('.story-listings .container p:nth-child(2)').attr('aria-level','2');
$("h2.custh2 a.cust_btn").attr("aria-label","TRY THE SAMPLER of Low-Sugar Oatmeal");
$('br').attr('aria-hidden','true');
$('div#rebuy-smart-cart-announcement-bar').removeAttr('tabindex'); 
// $('div#product-variants').insertBefore('.rc-container-wrapper');
}, 3000);
}, 3000);


$(document).ready(function() {
  $('img[src="//www.mylklabs.com/cdn/shop/files/nutrition.png"]').attr('alt','Nutrition facts comparison: Almond (230 calories) and Blueberry (200 calories) Oatmeal cups with additional info.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/Asset222.jpg?v=1701452465"]').attr('alt','Blueberry oatmeal cup highlighting pure maple sugar, real blueberries, and fiber & protein benefits.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/Asset235.jpg?v=1701452484"]').attr('alt','Apple oatmeal cup highlighting real Granny Smith apples, a twist on a classic flavor, and ready in minutes benefits.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/Asset242.jpg?v=1710201910"]').attr('alt','Strawberry oatmeal cup highlighting real strawberries, Madagascar vanilla, and convenience as fast and healthy.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/Asset469-min.jpg?v=1710204110"]').attr('alt','Banana nut oatmeal cup emphasizing real fruit, ease of adding water, and convenience as a fast and healthy option.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/mylk-labs-nutrition.png?v=1689691229"]').attr('alt','Nutrition facts comparison: Almond (230 calories) and Blueberry (200 calories) Oatmeal cups with additional info.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/nutrition.png?v=1697408127"]').attr('alt','Nutrition facts comparison: Almond (230 calories) and Blueberry (200 calories) Oatmeal cups with additional info.');
  $('img[src="//www.mylklabs.com/cdn/shop/files/Asset_86.png?v=1689722943"]').attr('alt','Nutrition facts comparison: Apple (220 calories) and Blueberry (200 calories) Oatmeal cups with additional info.');
});

$(document).ready(function () {
  var existCondition = setInterval(function () {
      if ($('div#product-variants').length) {
          clearInterval(existCondition);
          runMyFunctionrmvtb();
      }
  }, 5000);

  function runMyFunctionrmvtb() {
    $('div#product-variants').insertBefore('.rc-container-wrapper');
  }
});

$(document).ready(function() {
  setInterval(function() {
    $('.owl-item.cloned').attr('aria-hidden', 'true');
}, 1000);
});

$(document).ready(function() {
  $("#searchfocus").click(function() {
    $('#search').focus();
  });
});
$('h3,h4,h5,h6').each(function(){
  if( $(this).text().trim() === '' )
      $(this).remove();
});
  $(document).ready(function() {
    $(".size-swatches").click(function () {
        $(".size-swatches").removeClass("active");
        // $(".tab").addClass("active"); // instead of this do the below 
        $(this).addClass("active");   
    });
    });

$('.faq-area ul li button').click(function (e) {
  e.preventDefault();
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });
});
/* video_transcript-js_start */
$('button.collapsible').click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  });
  $("button.collapsible").click(function () {
    $(".content").attr('aria-hidden', function (i, attr) {
      return attr == 'false' ? 'true' : 'false'
    });
  });
  var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}
  /* video_transcript-js_end */
  var intervalID = window.setInterval(myCallback, 50);
      function myCallback() {
          var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
          if (textAreaCheck.length > 0) {
                 jQuery(textAreaCheck).attr('aria-label', 'g-recaptcha-response');
                 console.log(jQuery(textAreaCheck));
            clearInterval(intervalID);
          }
       }  


       $( document ).ready(function() {
        //wait until the last element (#checkout-step-shipping_method) being rendered
        var existCondition = setInterval(function() {
         if ($('main#main-content section.rc-login').length) { 
          clearInterval(existCondition);
          runMyFunction2();
         }
        }, 200);
    
        function runMyFunction2(){
         console.log("");
         $('header.rc-login--header a.rc-login--header-link').attr('aria-label','recharge secured, this link opens in new window');
        }
      });

      $(document).ready(function () {
        var existCondition = setInterval(function () {
            if ($('.old-price+.price.recharge-inner-most-price').length) {
                clearInterval(existCondition);
                runMyFunctionrmvtb();
            }
        }, 200);
    
        function runMyFunctionrmvtb() {
            $('.old-price+.price.recharge-inner-most-price').attr('aria-label', 'Sale Price ' + $('.recharge-inner-most-price').text());
        }
    });